import api from "./api";

export const settingsService = {
  // Get main dashboard statistics based on logged-in user role
  getDashboard: async () => {
    const response = await api.get("/dashboard");
    return response.data;
  },

  // Get system/game settings
  getSettings: async () => {
    const response = await api.get("/settings");
    return response.data;
  },

  // Update game settings (SUPER_ADMIN only)
  updateSettings: async (settingsData) => {
    const response = await api.put("/settings", settingsData);
    return response.data;
  }
};

export default settingsService;
